import { OrganizationLevelService } from '../../../services/organizationLevel.service';
import { CustomEntity } from './../../../models/customEntity.model';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { UserProfile } from 'src/app/models/userProfile.model';
import { SensorAssignment } from 'src/app/models/sensorAssignment.model';
import { SensorAssignmentService } from 'src/app/services/sensorAssignment.service';
import { ActivatedRoute } from '@angular/router';
import { CustomEntityService } from 'src/app/services/customEntity.service';
import { DatePipe } from '@angular/common';
import { OrganizationLevel } from 'src/app/models/organizationLevel.model';

@Component({
  standalone: false,
  selector: "app-report-header",
  templateUrl: "./report-header.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./report-header.component.scss"]
})
export class ReportHeaderComponent implements OnInit {
  constructor(
    private userService: UserService,
    private sensorAssignmentService: SensorAssignmentService,
    private route: ActivatedRoute,
    private customEntityService: CustomEntityService,
    private organizationService: OrganizationLevelService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.initialize();
  }

  userData: UserProfile;
  today = new Date();
  sensorAssignmentData: SensorAssignment;
  formattedRange = '';
  sensorAssignmentId: string;
  customEntity: CustomEntity;
  organizationLevel: OrganizationLevel;

  private initialize() {
    this.userService.getCurrentUserProfile().subscribe((data) => {
      this.userData = data;
    });
    this.sensorAssignmentId = this.route.snapshot.params.id;
    this.loadSampleDetails(this.sensorAssignmentId);
  }

  private loadSampleDetails(id: string | undefined) {
    this.sensorAssignmentService.getById(id).subscribe((data) => {
      this.sensorAssignmentData = data;
      this.formattedRange = this.formatDateTime(data?.startDate as unknown as string, data?.endDate as unknown as string);
      this.getCustomEntity(this.sensorAssignmentData.endPointId);
    });
  }

  private getCustomEntity(id: string | undefined) {
    this.customEntityService.getCustomEntity(id).subscribe((data) => {
      this.customEntity = data;
      this.getOrganizationLevel(this.customEntity.organizationLevelId);
    });
  }

  private getOrganizationLevel(id: string | undefined) {
    this.organizationService.getById(id).subscribe((data) => {
      this.organizationLevel = data;
    });
  }

  formatDateTime(
    startDate: string | undefined,
    endDate: string | undefined
  ): string {
    if (!startDate || !endDate) {
      return "";
    }

    // parse the start and end dates
    const start = new Date(startDate);
    const end = new Date(endDate);

    // format the start and end times using the DatePipe
    const startFormatted = this.datePipe.transform(
      start,
      "MMM dd yyyy, hh:mma"
    );
    const endFormatted = this.datePipe.transform(end, "hh:mma");

    // check if the end date is the same as the start date
    const sameDay =
      start.getDate() === end.getDate() &&
      start.getMonth() === end.getMonth() &&
      start.getFullYear() === end.getFullYear();

    // return the formatted string
    if (sameDay) {
      return `${startFormatted} - ${endFormatted}`;
    } else {
      const endFormattedDate = this.datePipe.transform(end, "MMM dd yyyy");
      return `${startFormatted} - ${endFormattedDate}, ${endFormatted}`;
    }
  }
}




